import { createComponent } from '@carvana/merch-components';
import type { ButtonProps } from '@carvana/showroom-forms/Button/Base/Button';
import Primary from '@carvana/showroom-forms/Button/Primary';
import Secondary from '@carvana/showroom-forms/Button/Secondary';
import Tertiary from '@carvana/showroom-forms/Button/Tertiary';
import styles from './Button.module.css';

export type { ButtonProps };

export const PrimaryButton = createComponent<ButtonProps>(Primary, {
  className: styles.button
});

export const SecondaryButton = createComponent<ButtonProps>(Secondary, {
  className: styles.button
});

export const TertiaryButton = createComponent<ButtonProps>(Tertiary, {
  className: styles.button
});
